import { InstalledApplication } from '@era/locations-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectUniqueIdFromApplication(application: InstalledApplication) {
  const key: string = [application.locationId, application.deviceId, application.bundleIdentifier].join('-');
  return key;
}

export const adapter: EntityAdapter<InstalledApplication> = createEntityAdapter<InstalledApplication>({
  selectId: selectUniqueIdFromApplication,
});

export type InstalledApplicationsState = EntityState<InstalledApplication>;

export const initialState: InstalledApplicationsState = adapter.getInitialState();
